import './index.scss';

import { Component } from 'react';
import { BraxDateTimeField, BraxSelectField, BraxTextField } from 'design-system';

import paymentInterval, { PaymentInterval } from '../../../../variables/payment-interval';
import paymentMethod, { PaymentMethod } from '../../../../variables/payment-method';
import paymentInstallments, { PaymentInstallments } from '../../../../variables/payment-installments';
import planPrices from '../../../../variables/plan-prices';
import masks from '../../../../variables/masks';
import t from '../../../../utils/i18n';
import formatters from '../../../../utils/formatters';
import payment from '../../../../utils/payment';
import Plan from '../../../../view-model/plans/Plan';

export type CheckoutStepTwoFieldsProps = {
    isForeign: boolean,
    interval: PaymentInterval,
    installments: PaymentInstallments,
    method: PaymentMethod,
    plan: Plan,
    cardNumber?: string,
    disabled: boolean
};

export default class CheckoutStepTwoFields extends Component<CheckoutStepTwoFieldsProps> {

    paymentIntervalOptions = [...paymentInterval];

    paymentInstallmentsOptions = [...paymentInstallments];

    paymentMethodOptions = [...paymentMethod];

    prices: typeof planPrices = Object.keys(planPrices).reduce((prices, key) => ({
        ...prices,
        [key]: {
            monthly: formatters.moneyToInt(planPrices[key].monthly),
            yearly: formatters.moneyToInt(planPrices[key].yearly)
        }
    }), {});

    render() {
        // const difference = this.prices[this.props.plan.id].monthly - this.prices[this.props.plan.id].yearly;

        const brand = this.props.cardNumber ? payment.Iugu.utils.getBrandByCreditCardNumber(this.props.cardNumber) : undefined;

        return (
            <div className={`checkout-step-two-field ${this.props.disabled ? 'step-disabled' : ''}`}>
                <h3>2. { t('Pagamento') }</h3>

                <BraxSelectField
                    label={t('Condição de pagamento')}
                    name="interval"
                    options={this.paymentIntervalOptions}
                    disabled={this.props.disabled}
                />

                <BraxSelectField
                    label={t('Meio de pagamento')}
                    name="paymentMethod"
                    options={this.paymentMethodOptions}
                    disabled={this.props.disabled || this.props.interval === 'monthly' || this.props.isForeign}
                />

                { this.props.method === 'credit_card' ? (<>
                    { this.props.interval === 'yearly' ? (
                        <BraxSelectField
                            label={t('Número de parcelas')}
                            name="installments"
                            options={this.paymentInstallmentsOptions}
                            disabled={this.props.disabled}
                        />
                    ) : null }

                    <BraxTextField
                        type="text"
                        name="creditCardName"
                        label={t('Nome do titular')}
                        placeholder={t('ex. Gabriel dos Santos')}
                        disabled={this.props.disabled}
                    />

                    <BraxTextField
                        type="text"
                        mask={masks.creditCard}
                        name="creditCardNumber"
                        label={t('Número do cartão')}
                        placeholder={t('ex. 5555 6666 7777 8884')}
                        disabled={this.props.disabled}
                    />

                    <BraxDateTimeField
                        format="month"
                        name="creditCardExpiration"
                        label={t('Data de validade')}
                        placeholder={t('ex. 09/2024')}
                        disabled={this.props.disabled}
                    />

                    <BraxTextField
                        type="text"
                        mask={masks.creditCardCVV}
                        name="creditCardCVV"
                        label={t('CVV')}
                        placeholder={t(brand === 'amex' ? 'ex. 1902' : 'ex. 123')}
                        disabled={this.props.disabled}
                    />
                </>) : null }

                {/* <p className={`hint ${this.props.interval === 'monthly' ? 'destructive' : 'success'}`}>
                    { t('Importante') }:

                    <br />

                    { t(
                        `Nesta condição de pagamento você está ${this.props.interval === 'monthly' ? 'deixando de economizar' : 'economizando'} %n ao mês e %n ao ano.`,
                        formatters.numberToMoney(difference / 100),
                        formatters.numberToMoney(difference * 12 / 100)
                    ) }
                </p> */}
            </div>
        );
    }

};
